export default class Icd {
    code:string;
    name:string;
    pinYin:string;
    abbr:string;
}


// WEBPACK FOOTER //
// ./src/store/entities/icd.ts